import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import LocalizedLabel from '@/components/LocalizedLabel';
import SecondsCountdown from '@/components/SecondsCountdown';
import { gatewayApi } from '@/api';
import { gatewayMock } from '@/mocks';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(LocalizedLabel);
Vue.use(SecondsCountdown);

sync(store, router);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

if (process.env.NODE_ENV === 'development') {
  gatewayMock.initMasterMock();
}

gatewayApi.init();
gatewayApi.setListeners();
